import { ORDERS_PERIOD_FILTER_EVENTS } from './global-events';

export const ordersPeriodCalendarEventMap = {
  'range-selected': ORDERS_PERIOD_FILTER_EVENTS.ORDERS_PERIOD_FILTER_DATES_RANGE,
};

export const ordersPeriodFilterOptions = [
  {
    id: 'last_12_months',
    name: 'Останні 12 місяців',
    event: ORDERS_PERIOD_FILTER_EVENTS.ORDERS_PERIOD_FILTER_LAST_12_MONTHS,
    options: {
      type: 'checkbox',
      activeFilter: false,
    },
  },
  {
    id: 'months',
    name: 'Місяць',
    event: ORDERS_PERIOD_FILTER_EVENTS.ORDERS_PERIOD_FILTER_MONTH,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'weeks',
    name: 'Тиждень',
    event: ORDERS_PERIOD_FILTER_EVENTS.ORDERS_PERIOD_FILTER_WEEK,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'days',
    name: 'День',
    event: ORDERS_PERIOD_FILTER_EVENTS.ORDERS_PERIOD_FILTER_DAY,
    options: {
      type: 'checkbox',
    },
  },
];
